"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _router = require("@/router");
var _default = exports.default = {
  name: 'Principal',
  computed: {
    keepAliveList: function keepAliveList() {
      return this.filterKeepAliveRouter(_router.routes);
    },
    key: function key() {
      return this.$route.path;
    }
  },
  methods: {
    filterKeepAliveRouter: function filterKeepAliveRouter(routes) {
      var keepAliveList = [];
      var _filterRouter = function filterRouter(routes2) {
        _(routes2).forEach(function (route) {
          if (route.meta && route.meta.keepAlive) keepAliveList.push(route.name);
          if (route.children && route.children.length) _filterRouter(route.children);
        });
        return keepAliveList;
      };
      return _filterRouter(routes);
    }
  }
};